import cmp from './VendorProfile'

export default cmp
